import { fillStringZeros, leadZero } from './strings'

export const millisecondsToHummerTime = (value = 0, ms = false) => {
  if ([ 'string', 'number' ].includes(typeof value)) {
    value = parseFloat(value / 1000, 10).toFixed(3)
    if (!isNaN(value)) {
      const parts = []
      const result = []

      const hours = Math.floor(value / 60 / 60)
      const minutes = Math.floor(value / 60) % 60
      const seconds = Math.floor(value - minutes * 60)
      const milliseconds = value.slice(-3)

      if (hours > 0) {
        parts.push(hours)
      }
      parts.push(leadZero(minutes))
      parts.push(leadZero(seconds))

      result.push(parts.join(':'))

      if (ms) {
        result.push(fillStringZeros(milliseconds, 3))
      }

      return result.filter(Boolean).join('.')
    }
  }
}

export const numberToPxOrString = value => {
  if (![ 'string', 'number' ].includes(typeof value)) {
    return undefined
  }

  return typeof value === 'string' ? value : `${value}px`
}
